import { on } from './app/store'

/**
 * The header and footer bars float over the page without a background. On
 * pages that scroll (Kontakt, Angebot) text would run straight underneath
 * their labels, so the bars get a soft scrim — but only while there is
 * content behind them: html.is-scrolled (header) and html.has-more-below
 * (footer).
 */
const THRESHOLD = 4
// Ignore small overflow such as the 32px of the logged-in admin bar.
const MIN_OVERFLOW = 40

export function startScrollState() {
  const html = document.documentElement
  let frame = 0

  const update = () => {
    frame = 0
    const { scrollY, innerHeight } = window
    const scrollHeight = html.scrollHeight
    html.classList.toggle('is-scrolled', scrollY > THRESHOLD)
    html.classList.toggle('has-more-below', scrollY + innerHeight < scrollHeight - MIN_OVERFLOW)
  }

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update)
  }

  window.addEventListener('scroll', schedule, { passive: true })
  window.addEventListener('resize', schedule)
  // New page content changes the scroll height.
  on('page-view', schedule)
  window.addEventListener('load', schedule)
  // So does everything that happens without a scroll, resize or visit: the
  // easy-mode remount (full-screen sliders ↔ plain lists), an opened FAQ
  // answer, late images and fonts. The page flows in <body> (<html> is fixed
  // at 100% height), so its size tracks the scroll height.
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body)
  update()
}
